import {combineReducers} from 'redux';
import data from './dataReducers';
import views from './viewReducer';

export default combineReducers({
  views,
  data,
});
